import React from 'react'
import axios from 'axios'
import {login} from '~/redux/user/actions'
import userStore from '~/redux/user/store'
import './styles.css'

class CreatePassword extends React.Component {
	constructor(props) {
    super(props)
    this.state = {
     	password: '',
      passwordConfirm: '',
      redirectToCardUpdate: false,
      passwordUpdated: false,
      errorMessage: '',
      token: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount(){
    const url = new URLSearchParams(window.location.search)
    this.setState({
      redirectToCardUpdate: url.has('updatePayment'),
      token: url.get('resetToken')
    })
  }

 
  handleSubmit(e) {
    e.preventDefault()
    this.setState({ errorMessage: '' })

   	if (!this.showFormErrors()) {
      console.log('form is invalid: do not submit')
    } else {
      const formData = document.forms.createPassword
      const data = {
      	resetToken: this.state.token,
        newPassword: formData.password.value
      }
      axios({
        url: '/identity/password',
        baseURL: window.settings.apiBaseUrl,
        method: 'post',
        params: {
          'site': window.settings.internalName
        },
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: JSON.stringify(data)
	    }).then((response) => {
          const user = {
            email: response.data.email,
            password: formData.password.value
          }
	        userStore.dispatch(login(user)).then(()=> {
            if(this.state.redirectToCardUpdate){
              window.location.href = "/user/account"
              window.sessionStorage.setItem('openUpdatecard', true)
            }else{
              window.location.href = "/";
          }
        })
      }).catch(error =>{
          this.setState({ errorMessage: error.response.data.error })
      })
    }
  }

  handleChange(e) {
    e.target.classList.add('active')

    this.setState({
      [e.target.name]: e.target.value
    })

    this.showInputError(e.target.name)
  }

  showFormErrors() {
    const inputs = document.querySelectorAll('.form-group input')
    let isFormValid = true

    inputs.forEach(input => {
      input.classList.add('active')

      const isInputValid = this.showInputError(input.name)

      if (!isInputValid) {
        isFormValid = false
      }
    })

    return isFormValid
  }

  showInputError(refName) {
    const validity = this.refs[refName].validity
    const label = document.getElementById(`${refName}Label`).textContent
    const error = document.getElementById(`${refName}Error`)
    const isPassword = refName.indexOf('password') !== -1
    const isPasswordConfirm = refName === 'passwordConfirm'

    if (isPasswordConfirm) {
      if (this.refs.password.value !== this.refs.passwordConfirm.value) {
        this.refs.passwordConfirm.setCustomValidity('Passwords do not match')
      } else {
        this.refs.passwordConfirm.setCustomValidity('')
      }
    }

    if (!validity.valid) {
      if (validity.valueMissing) {
        error.textContent = `${label} is a required field`
      } else if (isPassword && validity.patternMismatch) {
        error.textContent = `${label} should be longer than 4 chars`
      } else if (isPasswordConfirm && validity.customError) {
        error.textContent = 'Passwords do not match'
      }
      return false
    }

    error.textContent = ''
    return true
  }

	render(){
    return(
      <div className="create-password site-color">
        {!this.state.passwordUpdated &&
          <div className="form-container">
  				  <div className="header">Type your new password and confirm</div>
    				<form name="createPassword" onSubmit={this.handleSubmit} noValidate>
    					<div className="form-group">
    	          <label id="passwordLabel">Password</label>
    	          <input
    	            type="password"
    	            name="password"
    	            ref="password"
    	            placeholder="Password"
    	            value={ this.state.password }
    	            onChange={ this.handleChange }
    	            pattern=".{5,}"
    	            autoComplete="false"
    	            required />
    	          <div className="error" id="passwordError" />
    	        </div>
            	<div className="form-group">
              	<label id="passwordConfirmLabel">Confirm Password</label>
              	<input
                  type="password"
                  name="passwordConfirm"
                  placeholder="Confirm password"
                  ref="passwordConfirm"
                  value={ this.state.passwordConfirm }
                  onChange={ this.handleChange }
                  autoComplete="false"
                  required />
              	<div className="error" id="passwordConfirmError">{this.state.errorMessage}</div>
           		</div>
              <div className="button-container">
    						<button type="submit" className="button create-submit" value="Submit" onClick={this.handleSubmit}>Submit</button>
    					</div>
    				</form>
          </div>
        }
      </div>
		)
	}
}

export default CreatePassword
